/**
 * Code from Vue 2 mixin now in a Vue 3 composable.
 *
 * @author crm4f
 */
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import * as lst from '@/components/localStorage.js'

export const useLocationsCommon = () => {
  const authenticated = ref(null)
  const route = useRoute()
  const router = useRouter()
  
  onMounted(() => {
    authenticated.value = lst.getValue('authenticated')
    if (!authenticated.value) {
      document.title = 'Room Finder'
    }
  })

  // Goes back to previous router location
  const goBack = () => {
    if (route.query.auto) {
      router.go(-2)
    } else {
      router.go(-1)
    }
  }
  
  return {
   authenticated,
   goBack
  }
}
  